<template>
  <el-dialog
  class="dialogCodeImport dialogCustom"
  title="批量追加"
  width="624px"
  v-bind="$attrs"
  :close-on-click-modal="false"
  append-to-body
  :before-close="handleClose">
  <div class="codeImportConent">
    <div class="clickUploadWrap"><span class="clickUpload" @click="clickUploadFuc">下载授权码Excel清单模板</span></div>
    <div class="uploadContent">
      <el-input :class="[ errorMsg ? 'isError' : '' ]" :value="fileName" class="inputClass" placeholder="未选择任何文件">
        <div slot="suffix" class="inputImgWrap">
          <img src="../../../../assets/img/delete.svg" @click="deleteFile" v-show="fileName" class="inputImgClass"  alt="">
        </div>
      </el-input>
      <el-upload
        class="uploadClass"
        action="#"
        :before-upload="checkFile"
        :show-file-list="false"
        :multiple="false"
        :disabled="uploadDisabled"
        :http-request="e => importData(e)">
        <el-button type="primary" :loading="loading" >选择文件</el-button>
      </el-upload>
    </div>
    <div class="errorMsg" v-show="errorMsg" v-html="errorMsg"></div>
    <div style="margin-top: 10px; font-size: 12px;">支持导入的文件包括：授权码Excel清单模板、授权码清单</div>
  </div>
  <span slot="footer">
    <el-button :loading="loading" @click="handleClose">取 消</el-button>
    <el-button type="primary" :loading="loading" @click="saveCodeImport">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
import {activeLicense} from "~/request/configActiveLicense";
import requestActiveLicense from "~/request/requestActiveLicense";
import { mapState } from "vuex";
  export default {
    data() {
      return {
        loading: false,
        fileName:'',
        uploadDisabled: false,
        isError: false,
        errorMsg: '',
        codeList: [],
      };
    },
    computed:{
      ...mapState(['processId'])
    },
    methods: {
      deleteFile(){
        this.fileName = '';
        this.uploadDisabled = false;
        this.errorMsg = '';
        this.codeList = [];
      },
      importData(event){
        let formData = new FormData();
        formData.append('file', event.file, event.file.name);
        const param = {
          'processId': this.processId,
          'file': formData
        }
        this.uploadDisabled = true;
        requestActiveLicense.getAuthorizeListByFile(param).then(res => {
          this.loading = false;
          if (res.code === '0') {
            this.errorMsg = '';
            this.uploadDisabled = true;
            this.codeList = res.res;
          } else {
            this.errorMsg = `<div>${res.msg}</div>`;
            this.uploadDisabled = false;
          }
        })
      },
      checkFile(file){
        this.loading = true;
        this.fileName = file.name;
        const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
        const extension = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        if (!extension && !extension2) {
          this.errorMsg = '您导入的文件格式不正确，请上传excel格式的文件！';
          this.loading = false;
          return false
        } else if (file.size > 2 * 1024 * 1024) {
          this.errorMsg = '上传文件的大小不能超过 2MB！';
          this.loading = false;
          return false
        } else {
          return true
        }
      },
      clickUploadFuc(){
        const requestUrl = window.location.origin + activeLicense.downloadLicenseKeyTemplate;
        window.location.href = requestUrl;
      },
      handleClose(list) {
        if(Array.isArray(list)){
          this.$emit('cancelCodeImportDialog', list)
          return;
        }
        this.$emit('cancelCodeImportDialog')
      },
      saveCodeImport() {
        if(this.errorMsg){
          return;
        }
        if(!this.codeList.length){
          this.errorMsg = '请上传附件！';
          return;
        }
        const param = {
          'processId': this.processId,
          'list': this.codeList
        }
        requestActiveLicense.saveAuthorizeInfoBatch(param).then(res =>{
          if (res.code === '0') {
            this.$notify({
              title: '成功',
              message: res.msg || '操作成功',
              type: 'success',
            });
            this.handleClose(res.res);
          }else{
            this.errorMsg = res.msg || '操作失败';
            this.$notify({
              title: '失败',
              message:  res.msg || '操作失败',
              type: 'error',
            });
          }
        })
        // this.handleClose();
      }
    }
  };
</script>
<style lang="less" scoped>
.dialogCodeImport{
  /deep/ .el-dialog__body{
    padding: 6px 32px 32px 32px;
  }
  .codeImportConent{
    .clickUploadWrap{
      margin-bottom: 8px;
      .clickUpload{
        font-size: 12px;
        font-weight: 400;
        color: @currentColor;
        cursor: pointer;
      }
    }
    .uploadTip{
      margin-bottom: 10px;
    }
    .uploadContent{
      display: flex;
      // margin-bottom: 10px;
      .inputClass{
        flex: 1
      }
      .uploadClass{
        margin-left: 12px;
      }
      .isError /deep/ .el-input__inner{
        border-color: #f56c6c;
      }
      .inputImgWrap{
        display: inline-flex;
        height: 100%;
        align-items: center;
        .inputImgClass{
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
    }
    .errorMsg{
      white-space: pre-line;
      color: #f56c6c;
      max-height: 190px;
      overflow-y: auto;
    }
  }
}
</style>